import { type FC } from "react";
import Modal from "@root/shared/components/Modal";
import { Loading } from "@clientFrontend/features/scout/components/Loading";
import * as styles from "./styles.css";

type Props = {
  title: string;
  description: string;
};

export const LoadingModal: FC<Props> = ({ title, description }) => {
  return (
    <div className={styles.modalWrapper}>
      <Modal isShow headerTitleStyle="none" pcWidthType="small">
        <div className={styles.contentsWrapper}>
          <Loading isShadow={false} />
          <p>{title}</p>
          <p>{description}</p>
        </div>
      </Modal>
    </div>
  );
};
